function TextPreview(rawText = '') {
    const splitText = rawText?.split('\n');
    return (
        <>
            {splitText.map((text, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <p key={index}>{text}</p>
            ))}
        </>
    );
}
function SignatureArea({ info }) {
    const { signatory1, signatory2 } = info?.invConfig || {};

    return (
        <div className="flex justify-start mx-5 mb-5 print:mx-0 print:mb-5">
            <div className="flex gap-x-13">
                <div>{TextPreview(signatory1)}</div>

                <div>{TextPreview(signatory2)}</div>
            </div>
        </div>
    );
}

export default SignatureArea;
